import useAlias from '@alias';
import FormattedAlias from '@components/_shared/Translations/FormattedAlias';
import { Box, Typography } from '@mui/material';
import React from 'react';
import { ConnectionStatus } from '../../types';
import { formatLastUpdate } from '../../utils/connectionUtils';

interface TooltipContentProps {
  statusLabel: string;
  lastDataUpdate?: Date | null;
  displayStatus: ConnectionStatus;
}

const TooltipContent: React.FC<TooltipContentProps> = ({
  statusLabel,
  lastDataUpdate,
  displayStatus,
}) => {
  const alias = useAlias();

  return (
    <Box sx={{ maxWidth: 400 }}>
      <Typography
        variant='caption'
        display='block'
        fontWeight='bold'
        gutterBottom
      >
        <FormattedAlias id='Status' />: {statusLabel}
      </Typography>
      <Typography variant='caption' display='block'>
        <FormattedAlias id='Last Update' />:{' '}
        {formatLastUpdate(lastDataUpdate, alias)}
      </Typography>

      {displayStatus === ConnectionStatus.CONNECTED && <ConnectedStatus />}

      {displayStatus === ConnectionStatus.DISCONNECTED && (
        <Typography
          variant='caption'
          display='block'
          color='error.light'
          sx={{ mt: 1 }}
        >
          ✗ <FormattedAlias id='Connection lost - showing cached data only' />
        </Typography>
      )}

      {displayStatus === ConnectionStatus.RECONNECTING && (
        <Typography
          variant='caption'
          display='block'
          color='warning.light'
          sx={{ mt: 1 }}
        >
          ⟳ <FormattedAlias id='Reconnecting...' />
        </Typography>
      )}
    </Box>
  );
};

const ConnectedStatus: React.FC = () => {
  return (
    <>
      <Typography
        variant='caption'
        display='block'
        color='success.light'
        sx={{ mt: 1 }}
      >
        ✓ <FormattedAlias id='Receiving real-time updates' />
      </Typography>
      <Typography
        variant='caption'
        display='block'
        sx={{ mt: 1, fontStyle: 'italic' }}
      >
        <FormattedAlias id='Monitoring active alerts' />
      </Typography>
    </>
  );
};

export default TooltipContent;
